import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { AnatomicalSideLabelPipe, BaseLldTableComponent } from '../../shared';


/**
* Table of Limb Length Discrepancy in correction analysis.
*/
@Component({
	selector: 'lld-recap',
	templateUrl: './lld-recap.component.html',
	imports: [
		NgbCollapseModule,
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class LldRecapComponent extends BaseLldTableComponent {

	isCollapsed = true;

	/**
	* Get Limb Lenght Discrepancy measure of long leg.
	*/
	get longlegLLD_eoc(): string {
		return this.calculateLLD(this.eocMeasures?.eoc_ap_fullLength, this.defCLMeasures?.def_ap_fullLength_ctrlateral);
	}

	/**
	* Get Limb Lenght Discrepancy measure of femur.
	*/
	get femurLLD_eoc(): string {
		return this.calculateLLD(this.eocMeasures?.eoc_ap_femurLength, this.defCLMeasures?.def_ap_femurLength_ctrlateral);
	}

	/**
	* Get Limb Lenght Discrepancy measure of tibia.
	*/
	get tibiaLLD_eoc(): string {
		return this.calculateLLD(this.eocMeasures?.eoc_ap_tibiaLength, this.defCLMeasures?.def_ap_tibiaLength_ctrlateral);
	}

	/**
	* Get True Lenght measure.
	*/
	get trueLength_eoc(): number | undefined {
		return this.eocMeasures?.eoc_ap_femurLength && this.eocMeasures.eoc_ap_tibiaLength ? this.eocMeasures.eoc_ap_femurLength + this.eocMeasures.eoc_ap_tibiaLength : undefined;
	}

	/**
	* Get True Lenght measure of Limb Lenght Discrepancy.
	*/
	get trueLengthLLD_eoc(): string {
		return this.calculateLLD(this.trueLength_eoc, this.trueLengthCL);
	}

}
